import { Subscription } from 'rxjs/Subscription';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ProductService } from '../shared/services/product.service';
import { ProductFamily } from '../opc-app/productfamily/productfamily.model';
import { OPCConstant } from '../opc-app/opc.const';

import * as $ from 'jquery';
import { ProductLine } from '../opc-app/productline/productline.model';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth-service';
import { TokenRequest } from '../shared/models/tokenrequest.model';
import { UserService } from '../shared/services/user.service';
import { PartService } from '../shared/services/part.service';
import { OPCSettings } from '../shared/models/opcsettings.model';
import { AuthorizationService } from '../../app/authorization.service';
import { UserInfo } from '../../app/userinfo';
import { TokenResponse } from '@openid/appauth';
import { AfterViewInit } from '@angular/core/public_api';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfigService } from '../shared/services/configService';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  host: {
    '(document:click)': 'onHideMenu($event)'
  },
  encapsulation: ViewEncapsulation.None,
})

export class HeaderComponent implements OnInit, OnDestroy {
  productFamilies: ProductFamily[];
  subscription: Subscription;
  logoRbA: any;
  searchText: string;
  defaultImage: string;
  intallationpartsFamily: ProductFamily;
  byPassFamilyName: string;
  productLine: ProductLine;
  productFamilyImgPath: string;
  opcSettings: OPCSettings = new OPCSettings();
  isToken = false;
  public userInfo: UserInfo | null;
  public authorized: boolean;
  constructor(private _productService: ProductService, private _router: Router, public _authService: AuthService, private _configService: ConfigService,
    private _userService: UserService, private partService: PartService, public authorizationService: AuthorizationService, private spinner: NgxSpinnerService,) {
    this.byPassFamilyName = OPCConstant.BYPASS_FAMILY;
    if (localStorage.getItem('authorization.service.isToken')) {
      this.isToken = true;
    }
  }
  ngOnInit() {
    //this._configService.loadSettings();
    this.authorizationService.userInfos().subscribe((userInfo: UserInfo | null) => {
      this.userInfo = userInfo;
    });
    this.authorizationService.tokenResponse().subscribe((tokenResponse: TokenResponse | null) => {
      this.authorized = tokenResponse != null;
      if (this.authorizationService) {
        this.subscription = this._productService.getProductFamily().subscribe(res => {
          this.productFamilies = res;
          this.setProductFamilies(this.productFamilies);
        });
      }
    });
    this._productService.productFamilyChange.subscribe((productFamilies: ProductFamily[]) => {
      this.setProductFamilies(productFamilies);
    });
  }

  ngOnChanges() {
    if (!this.authorized && this.authorizationService.isSignInLoading) {
      this.spinner.show();
    } else {
      this.spinner.hide();
    }
  }

  setProductFamilies(pf: ProductFamily[]) {
    this.intallationpartsFamily = pf.find(p => p.productFamilyName === this.byPassFamilyName && p.isActive);
    this.productFamilies = pf.filter(p => p.productFamilyName !== this.byPassFamilyName && p.isActive);
    if (this.intallationpartsFamily) {
      this.getProductLine();
    }
  }
  getProductLine() {
    this._productService.getProductLineById(this.intallationpartsFamily.productFamilyID).subscribe(res => {
      this.productLine = res.productLines[0];
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  searchParts() {
    if (this.searchText) {
      const searchTextCopy = this.searchText.replace(new RegExp('/', 'g'), '$');
      this.partService.searchedPart.next(this.searchText);
      this._router.navigate(['search', searchTextCopy.trim()]);
    }
  }
  errorImage(event) {
    //event.target.src = this.defaultImage;
  }
  onHideMenu(event) {
    const selectedItem1 = $(event.target).parents('div#productFamilyItems.dropdown-menu').length > 0 ? true : false;
    const selectedItem2 = $(event.target).parents('div#manageItems.dropdown-menu').length > 0 ? true : false;
    const clickedItem = $(event.target).parents('div#navbarSecondaryMenu.secondary-menu').length > 0 ? true : false;
    const searchClick = $(event.target).parents('button#search-button').length > 0 ? true : false;

    if ((!clickedItem || selectedItem1 || selectedItem2) && event.target.id !== 'menuButton') {
      if ($($('#navbarSupportedContent')[0]).is(':visible') && $($('#navbarTogglerButton')[0]).is(':visible')) {
        $($('.navbar-toggler')[0]).click();
      }
    }
    if (!(this._router.url.substr(1, 6) === 'search' || searchClick || event.target.id === 'search-button')) {
      this.searchText = '';
    }
    if ((searchClick || event.target.id === 'search-button') && $($('.navbar-toggler')[0]).is(':visible')) {
      $($('.navbar-toggler')[0]).click();
    }
  }
}



// WEBPACK FOOTER //
// ./src/opc/header/header.component.ts